import { ShieldAlert } from 'lucide-react';
import { useCustomerCommsHold } from '@/hooks/messaging/useCustomerCommsHold';

/**
 * Full-width notice while the account's customer communications are on hold:
 * nothing — reminders, invoices, Iris replies, inbox messages — reaches a
 * customer until Notifi support lifts it. Shown to everyone in the account so
 * nobody wonders why a text "didn't go out".
 */
export function CustomerCommsHoldBanner() {
  const { data } = useCustomerCommsHold();
  if (!data?.held) return null;
  return (
    <div
      role="status"
      className="flex items-center gap-2 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/60 dark:text-amber-100"
    >
      <ShieldAlert size={15} className="shrink-0 text-amber-700 dark:text-amber-300" />
      <span className="min-w-0 flex-1">
        <span className="font-medium">Customer communications are on hold.</span>{' '}
        <span className="text-amber-900/80 dark:text-amber-200/80">
          No texts, emails or chat replies are sent to customers until your account goes live.
        </span>
      </span>
    </div>
  );
}
